/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformLogsRequest {
    getFixupPrototypeFunction() { return PlatformLogsRequest.fixupPrototype; }

    static newInstance(model: Partial<PlatformLogsRequest>): PlatformLogsRequest {
        let obj = Object.assign(new PlatformLogsRequest(), model);
        PlatformLogsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformLogsRequest>): PlatformLogsRequest {
        if (!model) return null;
        return PlatformLogsRequest.newInstance(<PlatformLogsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformLogsRequest) {
        if (!obj) return;

        models.PlatformLogsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformLogsRequest): boolean {
        Object.setPrototypeOf(obj, PlatformLogsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.logs_list) {
            for (let val of this.logs_list) {
                models.PlatformLogs.fixupPrototype(val);
            }
        }
    }

    /**
     * List of log entries
     */
    logs_list: Array<models.PlatformLogs>;

}
